<div class="container p-0 px-md-5">
	<h3 class="title text-center"><span class="btn-link" routerLink="/stores">Pontos de venda</span> / {{ store?.name }}
	</h3>

	<div class="box">
		<div class="row">
			<div *ngIf="store?.specialties.length" class="col">
				<h3>Serviços Clínicos</h3>
				<div class="list-group">
					<div *ngFor="let specialty of store?.specialties" class="list-item-group">
						{{ specialty.name }}
					</div>
				</div>
			</div>
			<div class="col">
				<div class="info d-flex flex-column">
					<div *ngIf="store?.address" class="item d-flex">
						<div class="item-image">
							<img src="assets/icons/address.svg" height="20px" />
						</div>
						<div class="p-2">
							{{ store?.address }}
							<br />
							{{ store?.postalcode }} {{ store?.city }}
						</div>
					</div>
					<div *ngIf="store?.phone" class="item d-flex">
						<div class="item-image">
							<img src="assets/icons/phone.svg" height="20px" />
						</div>
						<div class="p-2">{{ store?.phone }}</div>
					</div>
					<div *ngIf="store?.mobile" class="item d-flex">
						<div class="item-image">
							<img src="assets/icons/mobile.svg" height="20px" />
						</div>
						<div class="p-2">{{ store?.mobile }}</div>
					</div>
					<div *ngIf="store?.email" class="item d-flex">
						<div class="item-image">
							<img src="assets/icons/email.svg" height="20px" />
						</div>
						<div class="p-2"><a class="btn-link" href="mailto:{{ store?.email }}">{{ store?.email }}</a>
						</div>
					</div>
					<div [innerHTML]="store?.info"></div>
					<div class="d-none" *ngFor="let schedule of store?.schedules">
						<span *ngIf="schedule.start" class="px-2">
							{{ schedule.day }}
						</span>
						<span *ngIf="schedule.start" class="px-2"> {{ schedule.start }} - {{ schedule.end }} </span>
						<span *ngIf="schedule.start2" class="px-2"> {{ schedule.start2 }} - {{ schedule.end2 }} </span>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="container">
		<div #map style="width: 100%; height: 300px"></div>
	</div>
</div>

<app-appointment></app-appointment>